import { connect } from 'react-redux';
import Tasks from './app.tasks';
import { updateOrderView, loadOrders } from './reducers/order.reducers';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
});

const mapDispatchToProps = dispatch => ({
  updateOrderView: () => dispatch(updateOrderView()),
  reloadOrders: () => dispatch(loadOrders()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Tasks);
